var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgInteractionCount = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  width: "1em",
  height: "1em",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M42.17 38.19c-.55 2.66-1.36 5.27-2.34 7.79-.22.57-.48 1.11-.74 1.66-.13.29-.29.6-.53.75-.35.22-.52-.47-.55-.67-.17-.97-.49-1.93-.87-2.83-.1-.22-.6-1.46-.75-1.5-.21-.05-1.24.78-1.46.9-.51.27-1.03.5-1.57.7-1.12.41-2.27.69-3.45.83-3.81.44-8.35-.29-11.07-3.22-2.37-2.57-3.15-6.47-2.69-9.86.49-3.65 2.51-6.98 5.48-9.16 3.2-2.35 7.21-3.04 11.09-2.67.57.05.96.59.87 1.15-.12.72-.27 1.64-.29 2.3v.29c.09 2.58 1.55 5.02 4.09 5.96 1.15.43 3.18.64 4.37.74.53.04.94.49.92 1.02-.05 1.46-.18 4.24-.51 5.81Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M47.12 19.19c-1.31-2.31-4.05-3.61-6.73-3.07-3.06.62-4.99 3.3-5.09 6.25 0 .06-.01.11-.01.15 0 .03.01.08.01.14.09 2.58 1.55 5.02 4.09 5.96 2.56.96 5.51.15 7.19-1.97 1.66-2.09 1.85-5.16.54-7.46Zm-3.77 4.76c-.58.73-1.6 1.01-2.49.68-.88-.33-1.39-1.17-1.42-2.07v-.1c.04-1.02.7-1.95 1.77-2.16.92-.19 1.87.26 2.33 1.06.45.8.38 1.86-.19 2.59Z"
})));

const ForwardRef = /*#__PURE__*/forwardRef(SvgInteractionCount);
export default ForwardRef;